import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/dostavkee/_sidebar-layout/supports/')({
    onEnter: () => {
        document.title = 'Dostavkee - Помощь'
    },
})
